import React from 'react';
import { useWrapRequest } from 'use-wrap-request';
import { observer } from 'mobx-react';
import { useSearchReducer } from '../../../components/hooks/useSearchReducer';
import useInfiniteScroll from '../../../components/hooks/use-scroll';
import { Spinner } from '../../../components/spinner';
import { EmployeeContext } from '../index';
import { injectTSDI } from '../../../core/tsdi';
import { Api } from '../../../core/api';
import { ActivityPointsDto } from '../../../core/api/FitnessActivityClient';
import { ActivityPoints } from './activity-points';

export const EmployeeActivityPoints = observer(() => {
    const employee = React.useContext(EmployeeContext);
    const { fitnessActivityClient } = injectTSDI(Api);
    const [searchParams, dispatch] = React.useReducer(useSearchReducer, {
        size: 30,
        page: 0,
        sort: '-timestamp'
    });

    const [activityPoints, setActivityPoints] = React.useState<
        ActivityPointsDto[]
    >([]);

    const activityPointRequest = useWrapRequest(
        async (
            searchParams: QueryParamsDto,
            activities: ActivityPointsDto[]
        ) => {
            const result =
                await fitnessActivityClient.admin.activitySupportControllerGetActivityPoints(
                    { userId: employee.mySportsId!, ...searchParams }
                );
            setActivityPoints([...activities, ...result.data.content]);

            return { ...result.data, content: result.data.content || [] };
        },
        {}
    );

    const page = useInfiniteScroll({
        loading: activityPointRequest.loading,
        distance: 200
    });

    React.useEffect(() => {
        if (
            page > 0 &&
            activityPointRequest.$.totalPages &&
            activityPointRequest.$.totalPages > page
        ) {
            dispatch({ type: 'page', page });
        }
    }, [page]);

    React.useEffect(() => {
        activityPointRequest.request([searchParams, activityPoints]);
    }, [searchParams]);

    return (
        <>
            <ul className="divide-y divide-border rounded-xl border bg-card">
                {activityPoints.map((activityPoints) => (
                    <ActivityPoints
                        key={activityPoints.id}
                        activityPoints={activityPoints}
                    />
                ))}
            </ul>
            {activityPointRequest?.loading && (
                <div className="flex justify-center py-6">
                    <Spinner />
                </div>
            )}
        </>
    );
});

export default EmployeeActivityPoints;
